import { render, staticRenderFns } from "./Verificacao.vue?vue&type=template&id=729f5f7e&"
import script from "./Verificacao.vue?vue&type=script&lang=js&"
export * from "./Verificacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports